import { render, staticRenderFns } from "./_DeliveryRequestWrapper.vue?vue&type=template&id=3475245a&scoped=true&lang=pug&"
import script from "./_DeliveryRequestWrapper.vue?vue&type=script&lang=js&"
export * from "./_DeliveryRequestWrapper.vue?vue&type=script&lang=js&"
import style0 from "./_DeliveryRequestWrapper.vue?vue&type=style&index=0&id=3475245a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3475245a",
  null
  
)

export default component.exports